<template>
    <!-- 执行结果抽屉 -->
    <el-drawer v-model="drawerVisible" class="ssh-log-drawer" direction="btt" :show-close="false"
        :before-close="handleBeforeClose" size="85%" destroy-on-close="true">
        <template #header="{ close, titleId, titleClass }">
            <div :id="titleId" :class="[titleClass, 'ssh-log-head']">
                <span class="ssh-log-head__machine">{{ machine.name }}</span>
                <span class="ssh-log-head__addr">{{ machine.address }}</span>
                <span class="ssh-log-head__cmd">{{ cmd.name }}</span>
            </div>
            <el-button class="ssh-log-close" type="danger" plain @click="close">
                <el-icon class="el-icon--left">
                    <CircleCloseFilled />
                </el-icon>
                关闭
            </el-button>
        </template>
        <div id="outputContainer" class="ssh-log-body">
            <div class="ssh-log-cmd">
                <span class="ssh-log-cmd__label">执行模板</span>
                <code class="ssh-log-cmd__text">{{ cmd.contentTa }}</code>
            </div>
            <div class="ssh-log-cmd" v-if="resolvedCmd && resolvedCmd !== cmd.contentTa">
                <span class="ssh-log-cmd__label ssh-log-cmd__label--resolved">实际执行</span>
                <code class="ssh-log-cmd__text">{{ resolvedCmd }}</code>
            </div>
            <div class="ssh-log-output">
                <v-md-editor v-model="outputText" mode="preview" @copy-code-success="handleCopyCodeSuccess" />
            </div>
            <div class="ssh-log-done" v-if="runFinish">执行指令完成！</div>
        </div>
    </el-drawer>
</template>

<script>
import { ElMessage } from 'element-plus';

export default {
    name: 'SshLogDrawer',
    props: {
        visible: { type: Boolean, default: false },
        machine: { type: Object, default: () => ({}) },
        cmd: { type: Object, default: () => ({}) },
        output: { type: String, default: '' },
        runFinish: { type: Boolean, default: false },
        resolvedCmd: { type: String, default: '' }
    },
    // close 交给父组件处理（需二次确认并清理定时器）
    emits: ['update:visible', 'update:output', 'close'],
    computed: {
        drawerVisible: {
            get() {
                return this.visible;
            },
            set(value) {
                this.$emit('update:visible', value);
            }
        },
        outputText: {
            get() {
                return this.output;
            },
            set(value) {
                this.$emit('update:output', value);
            }
        }
    },
    methods: {
        handleBeforeClose() {
            this.$emit('close');
        },
        handleCopyCodeSuccess() {
            ElMessage({
                message: '复制成功',
                type: 'success',
                duration: 1 * 1000
            });
        }
    }
};
</script>

<!-- 抽屉会挂到 body 下，样式需要放在非 scoped 块里，并统一带 .ssh-log-drawer 前缀 -->
<style lang="scss">
.ssh-log-drawer {
    overflow: hidden;
    border-radius: 16px 16px 0 0;
}

.ssh-log-drawer .el-drawer__header {
    gap: 12px;
    margin-bottom: 0;
    padding: 14px 18px;
    border-bottom: 1px solid #eef1f6;
    background: linear-gradient(180deg, #fbfcfe 0%, #ffffff 100%);
}

.ssh-log-drawer .el-drawer__title {
    margin: 0;
}

.ssh-log-drawer .el-drawer__body {
    padding: 16px 18px 24px;
}

.ssh-log-drawer .ssh-log-head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.ssh-log-drawer .ssh-log-head__machine {
    font-size: 15px;
    font-weight: 600;
    color: #1f2d3d;
}

.ssh-log-drawer .ssh-log-head__addr {
    font-size: 13px;
    color: #8a94a6;
}

.ssh-log-drawer .ssh-log-head__cmd {
    padding: 2px 10px;
    border-radius: 999px;
    background-color: #eaf1fd;
    color: #2f6fed;
    font-size: 12px;
    font-weight: 500;
}

.ssh-log-drawer .ssh-log-close {
    flex: 0 0 auto;
    height: 34px;
    border-radius: 9px;
}

/* 执行指令 */
.ssh-log-drawer .ssh-log-cmd {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid #eef1f6;
    border-radius: 10px;
    background-color: #f7f9fc;
}

.ssh-log-drawer .ssh-log-cmd + .ssh-log-cmd {
    margin-top: 8px;
}

.ssh-log-drawer .ssh-log-cmd__label {
    flex: 0 0 auto;
    font-size: 13px;
    font-weight: 600;
    color: #f56c6c;
}

.ssh-log-drawer .ssh-log-cmd__label--resolved {
    color: #2f6fed;
}

.ssh-log-drawer .ssh-log-cmd__text {
    flex: 1 1 auto;
    min-width: 0;
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 13px;
    line-height: 1.5;
    color: #1f2d3d;
    white-space: pre-wrap;
    word-break: break-all;
}

/* 执行结果：横向内边距清零，与上方指令块左对齐 */
.ssh-log-drawer .ssh-log-output {
    margin-top: 12px;
}

.ssh-log-drawer .ssh-log-output .vuepress-markdown-body {
    overflow: hidden;
    padding-left: 0;
    padding-right: 0;
}

/* 代码块自带左右 -1.5rem 负外边距（用于抵扣主题的 2.5rem 内边距），需一并归零，
   否则代码块两侧溢出，行号列与复制按钮会被裁切 */
.ssh-log-drawer .ssh-log-output .vuepress-markdown-body div[class*=v-md-pre-wrapper-] {
    margin-left: 0;
    margin-right: 0;
}

.ssh-log-drawer .ssh-log-done {
    margin-top: 20px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: #67c23a;
}
</style>
